/**
 * Box open mode enum
 * ---
 * @enum string
 * @readonly
 */
export const E_Box_OpenMode = {
	DO_NOT_OPEN: "DO_NOT_OPEN",
	OPEN_NOW: "OPEN_NOW",
	OPEN_DELAYED: "OPEN_DELAYED",
};
